import React from "react";

import MenuList, { TMenuList } from "../../components-v2/MenuList";

const MenuNavList = (props: TMenuList) => {
  return <MenuList {...props} />;
};

export default MenuNavList;
